export default "__VITE_ASSET__rnXLhmeI__"